<template>
  <div id="app">
    <b-overlay :show="show" rounded="sm">
      <b-navbar toggleable="lg" type="dark" class="navbar">
        <!-- Marca de la barra -->
        <router-link to="/" class="navbar-brand ps-3">  <img height="40" :src="require('@/assets/img/lqn.png')" alt="Logo" />
          RUP LUQUIN</router-link>
        <!-- Botón de colapso -->
        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <!-- Contenido colapsable -->
        <b-collapse id="nav-collapse" is-nav>
          <!-- Elementos de navegación alineados a la derecha -->
          <b-navbar-nav class="ml-auto">
            <router-link v-if="!isAuthenticated" to="/login" class="nav-link">
              <b-icon icon="person-fill"></b-icon> Ingresar
            </router-link>

            <router-link
              v-if="isAuthenticated && user && isAdmin"
              to="/providers/list"
              class="nav-link"
            >
              Proveedores
            </router-link>
            <router-link
              v-else-if="isAuthenticated && user && !isAdmin"
              to="/providers/edit"
              class="nav-link"
            >
              Mis Datos
            </router-link>
            <b-nav-item-dropdown v-if="isAuthenticated" right>
              <!-- Encabezado del dropdown con el nombre del usuario -->
              <template #button-content>
                <b-icon icon="person-fill"></b-icon>
                {{ user.name || "Usuario" }}
              </template>
              <!-- Información del usuario con iconos -->
              <b-dropdown-item disabled>
                <i class="fas fa-user"></i> {{ user.name }}
              </b-dropdown-item>
              <b-dropdown-item disabled>
                <i class="fas fa-envelope"></i> {{ user.email }}
              </b-dropdown-item>
              <b-dropdown-divider></b-dropdown-divider>
              <!-- Botón de cierre de sesión -->
              <b-dropdown-item @click="logout">
                <i class="fas fa-sign-out-alt"></i> Cerrar Sesión
              </b-dropdown-item>
            </b-nav-item-dropdown>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
      <br />
      <router-view />
    </b-overlay>
    <b-modal
      v-model="isShowModalUnauthenticated"
      id="modal-unauthenticated"
      title="Eliminar archivo"
      hide-footer
      centered
      hide-header
    >
      <b-container>
        <b-row>
          <b-col class="pt-3 pb-4">
            <h4 align="center">
              Se cerró la sesión, desea iniciar sesión nuevamente?
            </h4>
          </b-col>
        </b-row>
        <b-row align-h="between">
          <b-col>
            <b-button
              variant="outline-secondary"
              @click="showModalUnauthenticated(false)"
            >
              Cancelar
            </b-button>
          </b-col>
          <b-col align="right">
            <b-button
              variant="outline-danger"
              @click="login"
            >
              Aceptar
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";

export default {
  computed: {
    ...mapGetters(["isAuthenticated"]),
    ...mapGetters(["user"]),
    ...mapGetters(["isAdmin"]),
    ...mapGetters(["isShowModalUnauthenticated"]),
    show() {
      return this.$store.getters.getLoadingApp;
    },
  },
  mounted() {
    this.$store.dispatch("checkUser");
  },
  methods: {
    ...mapMutations(['showModalUnauthenticated']),
    login() {
      this.showModalUnauthenticated(false);
      this.$route.path !== "/login" && this.$router.push("/login");
    },
    ...mapActions(["logout"]),
  },
};
</script>
<style>
.navbar{
  background-color: #23405c !important;
  padding: 0 10pt 0 10pt !important;
}
.pointer {
  cursor: pointer;
}
tr {
  font-size: 10pt;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2e6581;
}
label {
  display: inline-block;
  margin-bottom: 1pt !important;
}
</style>
